import React, { useState,useEffect } from 'react';
import { 
  Box, 
  Tabs, 
  Tab, 
  Container,
  CssBaseline,
  Alert,
  Typography
} from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Layout from "./Layout";
import ShopComponent from './components/ShopComponent';
import SettingsComponent from './components/SettingsComponent';
import { useAppContext } from './AppContext';

const SettingsDashboard = () => {
  const [value, setValue] = useState(0);
  const [isOffline, setIsOffline] = useState(false);
  const { t } = useAppContext();

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    // Add event listeners for online and offline events
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial status
    setIsOffline(!navigator.onLine);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <Layout>
    <Container>
    {isOffline && (
            <Alert severity="warning" sx={{ marginTop: '10px' }}>
              {t("You are offline. Some features may not be available.")}
            </Alert>
          )}
      <Typography variant="h4" sx={{ mt: 3, mb: 2 }}>
        {t("Settings")}
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label={t("Report tabs")}>
          <Tab label={t("Shop Information")} />
          <Tab label={t("General Settings")} />
        </Tabs>
      </Box>
      <Box sx={{ p: 3 }}>
        {value === 0 && <ShopComponent/>}
        {value === 1 && <SettingsComponent />}
      </Box>
    </Container>
    </Layout>
    </ThemeProvider>
  );
};

export default SettingsDashboard;
